export enum PosthogTrackingEvents {
  ApplianceCategoryStepLoaded = 'APPLIANCE_CATEGORY_STEP_LOADED',
  ApplianceTypeStepLoaded = 'APPLIANCE_TYPE_STEP_LOADED',
  ApplianceTypeNotSureSelected = 'APPLIANCE_TYPE_NOT_SURE_SELECTED',
  ApplianceNotSureSelected = 'APPLIANCE_NOT_SURE_SELECTED',
  PurchasePriceStepLoaded = 'PURCHASE_PRICE_STEP_LOADED',
  PurchaseDateStepLoaded = 'PURCHASE_DATE_STEP_LOADED',
  WarrantyLengthStepLoaded = 'WARRANTY_LENGTH_STEP_LOADED',
  ModelSerialNumberStepLoaded = 'MODEL_SERIAL_NUMBER_STEP_LOADED',
  ModelNumberSubmitted = 'MODEL_NUMBER_SUBMITTED',
  SerialNumberSubmitted = 'SERIAL_NUMBER_SUBMITTED',
  NameAndAddressFormStepLoaded = 'NAME_AND_ADDRESS_FORM_STEP_LOADED',

  // Multi Plan journey IG + OOG
  MultiPlanSalePageLoaded = 'MULTI_PLAN_SALE_PAGE_LOADED',

  MultiPlanWasOffered = 'MULTI_PLAN_WAS_OFFERED',
  MultiPlanWasOfferedSinglePlanSelected = 'MULTI_PLAN_WAS_OFFERED_SINGLE_PLAN_SELECTED',
  MultiPlanWasOfferedRegOnlySelected = 'MULTI_PLAN_WAS_OFFERED_REG_ONLY_SELECTED',

  MultiPlanBuildYourBundleCtaSelected = 'MULTI_PLAN_BUILD_YOUR_BUNDLE_CTA_SELECTED',

  MultiPlanProtectionPageMultiApplianceSelector = 'MULTI_PLAN_PROTECTION_PAGE_MULTI_APPLIANCE_SELECTOR',
  MultiPlanProtectionPageMultiApplianceSelectorContinue = 'MULTI_PLAN_PROTECTION_PAGE_MULTI_APPLIANCE_SELECTOR_CONTINUE',

  MultiPlanApplianceDetailsPageLoaded = 'MULTI_PLAN_APPLIANCE_DETAILS_PAGE_LOADED',
  MultiPlanApplianceDetailsFormChangeAppliances = 'MULTI_PLAN_APPLIANCE_DETAILS_FORM_CHANGE_APPLIANCES',
  MultiPlanContinueButtonToReviewCoverPage = 'MULTI_PLAN_CONTINUE_BUTTON_TO_REVIEW_COVER_PAGE',

  MultiPlanReviewCoverPageLoaded = 'MULTI_PLAN_REVIEW_COVER_PAGE_LOADED',
  MultiPlanReviewCoverChangeAppliances = 'MULTI_PLAN_REVIEW_COVER_CHANGE_APPLIANCES',
  MultiPlanReviewCoverChangeApplianceDetails = 'MULTI_PLAN_REVIEW_COVER_CHANGE_APPLIANCE_DETAILS',

  MultiPlanRegistrationSubmitted = 'MULTI_PLAN_REGISTRATION_SUBMITTED',
  MultiPlanRegistrationSubmittedSuccess = 'MULTI_PLAN_REGISTRATION_SUBMITTED__SUCCESS',
  MultiPlanCheckoutSuccess = 'MULTI_PLAN_CHECKOUT_SUCCESS',
  MultiPlanContactDetailsLoaded = 'MULTI_PLAN_CONTACT_DETAILS_LOADED',
  MultiPlanDirectDebitPageLoaded = 'MULTI_PLAN_DIRECT_DEBIT_PAGE_LOADED',

  // Single Plan journey
  SinglePlanQuoteRequested = 'SINGLE_PLAN_QUOTE_REQUESTED',
  SinglePlanProtectionPageLoaded = 'SINGLE_PLAN_PROTECTION_PAGE_LOADED',
  SinglePlanReviewCoverPageLoaded = 'SINGLE_PLAN_REVIEW_COVER_PAGE_LOADED',
  SinglePlanContactDetailsLoaded = 'SINGLE_PLAN_CONTACT_DETAILS_LOADED',
  SinglePlanDirectDebitPageLoaded = 'SINGLE_PLAN_DIRECT_DEBIT_PAGE_LOADED',
  SinglePlanRegistrationSubmitted = 'SINGLE_PLAN_REGISTRATION_SUBMITTED',
  SinglePlanRegistrationSubmittedSuccess = 'SINGLE_PLAN_REGISTRATION_SUBMITTED__SUCCESS',
  SinglePlanCheckoutSuccess = 'SINGLE_PLAN_CHECKOUT_SUCCESS',

  // Reg Only
  RegOnlyContactDetailsLoaded = 'REG_ONLY_CONTACT_DETAILS_LOADED',
  RegOnlyRegistrationSubmitted = 'REG_ONLY_REGISTRATION_SUBMITTED',
  RegOnlyRegistrationSubmittedSuccess = 'REG_ONLY_REGISTRATION_SUBMITTED_SUCCESS',
}
